export enum EVENT_FILTERS {
  ALL = "All",
  ACTIVE = "Active",
  INACTIVE = "Ended",
  // DRAFT = "Draft",
  ARCHIVED = "Deleted",
  UPCOMING = "Upcoming",
}

export const EVENT_PAGE_CACHE_TTL_SECONDS = 60 * 5;